import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=4f6a6d33"
import script from "./message-box.vue?vue&type=script&lang=js"
export * from "./message-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports